import { LogSessionContentRow } from '@/shared/types/analytics';

const cache = new Map<string, LogSessionContentRow>();

export const setPrefetchedSessionContent = (sessionId: string, data: LogSessionContentRow) => {
  cache.set(sessionId, data);
};

export const getPrefetchedSessionContent = (
  sessionId: string
): LogSessionContentRow | undefined => {
  return cache.get(sessionId);
};

export const clearPrefetchedSessionContent = (sessionId: string) => {
  cache.delete(sessionId);
};
